export enum ENUM__workspace_entity_feature {
  /*
   *
   * ENTITIES
   *
   */

  /*
   * COLLECTION
   */
  ENTITY_COLLECTION_VIEW = 'ENTITY_COLLECTION_VIEW',
  ENTITY_COLLECTION_UPDATE = 'ENTITY_COLLECTION_UPDATE',
  ENTITY_COLLECTION_CREATE = 'ENTITY_COLLECTION_CREATE',
  ENTITY_COLLECTION_DELETE = 'ENTITY_COLLECTION_DELETE',

  ENTITY_COLLECTION_SHARE = 'ENTITY_COLLECTION_SHARE',

  /*
   * SEARCH
   */
  ENTITY_SEARCH_VIEW = 'ENTITY_SEARCH_VIEW',
  ENTITY_SEARCH_UPDATE = 'ENTITY_SEARCH_UPDATE',
  ENTITY_SEARCH_CREATE = 'ENTITY_SEARCH_CREATE',
  ENTITY_SEARCH_DELETE = 'ENTITY_SEARCH_DELETE',

  ENTITY_SEARCH_SHARE = 'ENTITY_SEARCH_SHARE',

  //no VIEW here because it's controlling by USER_TASK_VIEW
  //no CREATE here because it's controlling by UPDATE
  ENTITY_GENERATION_UPDATE = 'ENTITY_GENERATION_UPDATE',

  /*
   *  USER TASK
   */
  ENTITY_USER_TASK_VIEW = 'ENTITY_USER_TASK_VIEW',
  ENTITY_USER_TASK_UPDATE = 'ENTITY_USER_TASK_UPDATE',
  ENTITY_USER_TASK_CREATE = 'ENTITY_USER_TASK_CREATE',
  ENTITY_USER_TASK_DELETE = 'ENTITY_USER_TASK_DELETE',

  ENTITY_USER_TASK_SHARE = 'ENTITY_USER_TASK_SHARE',

  /*
   *
   * OTHER
   *
   */

  /*
   * IMAGE
   */
  IMAGE_GET_AI_DESCRIPTION = 'IMAGE_GET_AI_DESCRIPTION',

  /*
   * MODELS
   */
  ML_ASSET_RESERVATION_VIEW = 'MODEL_ASSET_RESERVATION_VIEW',
  ML_ASSET_RESERVATION_UPDATE = 'MODEL_ASSET_RESERVATION_UPDATE',
}
